module.exports = __webpack_public_path__ + "media/images/social-icons/youtube-white-b8e003352ee902455dcb45332486e8ac.svg";